import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../../modules/auth';
import {BaseWebservice} from '../../../shared/base/base.webservice';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-post-invite',
  templateUrl: './post-invite.component.html',
  styleUrls: ['./post-invite.component.scss']
})
export class PostInviteComponent implements OnInit {

    constructor(


        private authService: AuthService,
        private _globalService:BaseWebservice,

    ) { }

    ngOnInit(): void {
    }


    endSession() {
        this.authService.logout()
        this._globalService.setDataAsdefault()
    }


}
